var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasErrors)?_c('div',{staticClass:"row"},_vm._l((_vm.errors),function(error){return _c('div',{staticClass:"col-md-12 error"},[_c('p',{staticClass:"error"},[_vm._v(_vm._s(error))])])})):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }